"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientTable/ImportPatients/ImportButton.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Tooltip = require('web/components/Tooltip');

const LABEL = 'Import patients from CSV'

/* D-97, e3: a round icon button left of the +, quieter than it, with the
 * app's dark tooltip on hover and keyboard focus (none on phones, where
 * HoverTooltip shows nothing). The Patients tab shows it to admins only. */
const ImportButton = ({ onClick, isDialogOpen }) => isDialogOpen
  // No tooltip over the dialog it opened (QA round 1).
  ? _react2.default.createElement('button', { type: "button", className: "dir-import-btn", 'aria-label': LABEL, onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}, _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}, "upload_file"))
  : (
  _react2.default.createElement(_Tooltip.HoverTooltip, {
    type: "dark",
    place: "bottom",
    showOnFocus: true,
    className: "dir-import-btn--tip",
    content: _react2.default.createElement(_Tooltip.TooltipHint, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 19}},  LABEL ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}

    , _react2.default.createElement('button', { type: "button", className: "dir-import-btn", 'aria-label': LABEL, onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}
      , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}, "upload_file")
    )
  )
    )

exports. default = ImportButton
